var configDatas = [
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 16571,
    name: "Bundle Offer Available",
    priority: 2,
    img_url: "1621936868011_a613.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 3,
    product_type: 0,
    exclude_products: null,
    product:
      "2670513193045,6842365706432,2670526201941,8629918695749,8616940044613,8629922922821,8603214020933",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/1621936868011_a613_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: null,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 16571,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1621936868011_a613.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-05-25T10:01:47.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 3,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 14849,
    name: "Pre Order",
    priority: 1,
    img_url: "1619710321898_a1010.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 2,
    product_type: 0,
    exclude_products: null,
    product:
      "6652184953024,6652193341632,6652185477312,6652191736000,6652187082944,7925119287553,7925298528513,7925298954497,7925299937537,7925301477633,7925302460673,7925303345409,7925306851585,7925309210881,7925310849281,7925313634561",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/1619710321898_a1010_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: null,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 14849,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: 0,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1619710321898_a1010.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-04-29T15:32:24.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 0,
    desktop_label_unlimited_left: 0,
    desktop_label_unlimited_width: -1,
    desktop_label_unlimited_height: -1,
    mobile_label_unlimited_top: 0,
    mobile_label_unlimited_left: 0,
    mobile_label_unlimited_width: -1,
    mobile_label_unlimited_height: -1,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 14852,
    name: "Hot Products",
    priority: 1,
    img_url: "1619710825198_label_shopify_2-15.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 7,
    product_type: 0,
    exclude_products: null,
    product:
      "2326235414613,4692793753685,2726740328533,4344080859221,4264411693141,4264140144725,5492774791,4697204260949,2740343603285,4712791572565,4769238188117,4182566404181,6885752930496,6885675761856,6885766791360,6885755453632,6885758599360,6880266289344,6880360693952,6880263766208,6880275562688,4613051908181,2670526201941,2670579351637,4520104951893,4183390060629,4095867945045,4419881533525,4419845881941,2716803629141,2716823224405,4711747977301,4755728662613,2379923488853,4790172450901,6726604587200,6802439274688,6803917930688,4736784105557,4183624941653,2445092585557,4335660761173,4528411574357,2685034889301,4100841930837,4638828003413,4401485217877,2410192502869,4717385711701,6964653392064,6964647723200,6964708245696",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/1619710825198_label_shopify_2_15_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: null,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 14852,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: 0,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1619710825198_label_shopify_2-15.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-04-29T15:38:05.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 20,
    desktop_height_label: 20,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 0,
    desktop_label_unlimited_left: 0,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 0,
    mobile_label_unlimited_left: 0,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 14853,
    name: "Limited Stocks Left",
    priority: 1,
    img_url: "1619711041597_label_shopify_2-05.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 0,
    product_type: 0,
    exclude_products: null,
    product:
      "4697204260949,6780093071552,6777024086208,6777023463616,6726634832064,6726633586880,6700392710336,6700394021056,6700408471744,6700405981376,4100841930837,6681970606272,6684022407360,6802446549184,6803914195136,6802458804416,6802462671040,7880700297473,6837033140416",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/1619711041597_label_shopify_2_05_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: null,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 14853,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: 0,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1619711041597_label_shopify_2-05.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-04-29T15:44:20.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 0,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 0,
    desktop_label_unlimited_left: 0,
    desktop_label_unlimited_width: -1,
    desktop_label_unlimited_height: -1,
    mobile_label_unlimited_top: 0,
    mobile_label_unlimited_left: 0,
    mobile_label_unlimited_width: -1,
    mobile_label_unlimited_height: -1,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 37121,
    name: "Next Order Window",
    priority: 0,
    img_url: "NextOrderWindow2.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 0,
    product_type: 1,
    exclude_products: null,
    product: "",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/13/assets/NextOrderWindow2_png?v=1643749287",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: 1,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 37121,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/customer/2984/NextOrderWindow2.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2022-02-01T21:01:28.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 35,
    mobile_height_label: 35,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 35,
    desktop_height_label: 35,
    desktop_fixed_percent_label: 1,
    mobile_position: 0,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 102698,
    name: "Last Orders for Christmas Sunday 4th December 23",
    priority: 0,
    img_url: "lastchristmasorders4th.png",
    pages: "1,2,3,4,7,5",
    enable_allowed_countries: 0,
    locations: "",
    position: 7,
    product_type: 3,
    exclude_products: 7,
    product: "",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/files/lastchristmasorders4th.png?v=1701880180",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: "all_customer_tags",
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 102698,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/customer/2984/lastchristmasorders4th.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2023-12-06T16:29:42.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids:
      "7806678761729,7836636938497,7866451820801,7792677224705,2732494487637,7849967059201,8747201167685,7798024110337,7945803006209,8717586956613,7826738807041,7836367061249,8717580861765,8666587070789,4335653290069,8631079829829,7924385513729,7809877639425,8735344492869,6756829036736,4264411693141,8735355404613,4697204260949,8741772820805,6649898008768,8645954109765,7801913606401,7829626683649,7570275434753,6965840478400,7561556361473,2670526201941,4769898561621,6693334876352,8695246913861,8629918695749,7777113145601,6726630572224,8693843394885,4736784105557,4335660761173,4634392526933,8579117384005",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 0,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time: null,
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: 0,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 13,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 15925,
    name: "Pre Order ",
    priority: 0,
    img_url: "1620989292729_a1008.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 2,
    product_type: 0,
    exclude_products: null,
    product: "8666588119365",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/1620989292729_a1008_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 15925,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: 0,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1620989292729_a1008.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-05-14T10:48:41.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 0,
    desktop_label_unlimited_left: 0,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 0,
    mobile_label_unlimited_left: 0,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 17216,
    name: "Order Window Now Closed",
    priority: 0,
    img_url: "1622558877689_a475.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 2,
    product_type: 0,
    exclude_products: null,
    product: "6638163034304",
    variant: null,
    collection: "",
    collection_image: null,
    inventory: 0,
    tags: "",
    excludeTags: null,
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/7/assets/1622558877689_a475_png?v=1622558899",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: null,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 17216,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1622558877689_a475.png",
    enable_visibility_period: 0,
    visibility_period: 0,
    createdAt: "2021-06-01T14:46:57.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 40,
    mobile_height_label: 40,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 40,
    desktop_height_label: 40,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 51856,
    name: "Express Delivery",
    priority: 0,
    img_url: "EXPRESS-delivery-512.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 6,
    product_type: 0,
    exclude_products: 6,
    product:
      "7619042246913,7491984752897,7619049914625,7619073802497,7626920329473,7621803704577,6911570936000,7620032299265,6912765362368,6911560745152,6911661113536,6912758612160",
    variant: "",
    collection: "242160959680",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/EXPRESS_delivery_512_png?v=1661518896",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: "all_customer_tags",
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 51856,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/customer/2984/EXPRESS-delivery-512.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2022-07-22T15:12:08.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 6,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 33746,
    name: "PRE ORDER WINDOW CLOSED",
    priority: 0,
    img_url: "1639646379098_PREORDERWINDOWCLOSED.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 2,
    product_type: 0,
    exclude_products: null,
    product:
      "7641552879873,7641624740097,7641557238017,7644809363713,4692795097173,4692793753685,7639114776833,7637817295105,7637774041345,4720438149205,4264715845717,4264717287509,4692068958293,4264711159893,7639093051649,7639130046721,7639122641153,7639136370945,2410199711829,2417949343829,2418030411861,2414725890133,4720560996437,2445240860757,2410192502869,2414673494101,2414501560405,2414758035541,6652184953024,6652193341632,6652185477312,6652191736000,6652187082944",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/23/assets/1639646379098_PREORDERWINDOWCLOSED_png?v=1656685574",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: 1,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 33746,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/2984/240/1639646379098_PREORDERWINDOWCLOSED.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-12-16T09:20:08.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 35,
    mobile_height_label: 35,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 35,
    desktop_height_label: 35,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 25582,
    name: "NEW",
    priority: 0,
    img_url: "a651.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 8,
    product_type: 0,
    exclude_products: null,
    product:
      "7641335431425,7641253118209,7641227624705,7641255084289,7641277006081,7641301516545,7641304760577,7641308954881,7641311346945,7641353847041,7641300566273,7641315803393,7641278906625,7641552879873,7641624740097,7641557238017,7570275434753,7805206987009,7788437405953,7792485073153,7737134842113,4691201130581,7498873569537,7498874061057,7498903552257,7787469832449,7788438454529,6887970504896,7810068513025,7774336614657,7798024110337,7806678761729,7848415854849,7848416870657,7848487289089,7848414904577,7848410546433,7848412938497,7848483684609,6925626048704,4612174938197,7792401842433,7857785798913,7857783505153,7857786552577,7857787011329,7857785241857,7860098138369,7860113015041,7860089684225,7860084179201,7860136640769,7860136935681,7862719709441,7862702309633,7862708076801,7862697787649,7862694248705,7862716989697,7862713811201,7855752184065,7858935660801,7871152652545,7871257051393,7764025671937,7765124120833,7851012817153,7851031429377,7797836054785,7801913606401,7792677224705,7904402178305,7919071133953,7919089189121,7919132836097,7919143321857,6756830806208,6802455756992,8353971044677,8358977241413,7989770256641,8358939951429,8359053852997,8358906724677,8358912459077,8359051624773,8359052476741,7989773926657,8358965510469,8358905971013,8353971339589,7989772484865,7989779562753,8358904987973,8358951420229,8358902825285,8358919340357,8358974652741,8353970258245,8359056081221,8353968783685,8358943654213,8358942015813,8358946931013,8358916522309,8358918095173,8358913573189,8352611139909,8359869514053,8352615727429,8353310179653,8359870497093,8359852310853,8353305329989,8352638173509,8352547995973,8352564511045,8359825113413,8359826751813,7991630528769,8359839695173,8352629588293,8353302348101,8352527384901,8359853982021,7991640850689,8352530104645,8359823343941,8359828226373,8579117384005,7756261294337,8579139862853,8582852510021,8579119153477,8579159589189,8603214020933,8636932620613,8636935700805,8636932915525,8636936585541,8636934684997,8579817963845,8601135448389,8659902890309,8659913572677,8659948142917,8659924418885,8659889783109,8659909607749,8659955974469,8659966689605,8659915145541,8659890569541,8659923927365,8659928613189,8659938181445,8659971768645,8666587070789,8666588119365,8666585923909,8626298519877,8693843394885",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/a651_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 25582,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/adminhtml/libs/27/a651.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-09-29T19:56:59.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 30,
    mobile_height_label: 30,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 30,
    desktop_height_label: 30,
    desktop_fixed_percent_label: 1,
    mobile_position: 8,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 24572,
    name: "Coming Soon",
    priority: 0,
    img_url: "a684.png",
    pages: "1,2,3,4,7",
    enable_allowed_countries: 0,
    locations: "",
    position: 0,
    product_type: 0,
    exclude_products: null,
    product: "8637858906437",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: 0,
    from_date: null,
    to_date: null,
    enable_discount_range: 0,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/1193/5694/t/24/assets/a684_png?v=1657189423",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 0,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: null,
    collection_image_type: 0,
    label_on_image: "1",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 24572,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/adminhtml/libs/27/a684.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2021-09-15T19:02:13.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 50,
    mobile_height_label: 50,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 50,
    desktop_height_label: 50,
    desktop_fixed_percent_label: 1,
    mobile_position: 0,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time:
      '[{"name":"Sunday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Monday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Tuesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Wednesday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Thursday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Friday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true},{"name":"Saturday","selected":false,"allDay":false,"timeStart":"00:00","timeEnd":"23:59","disabledAllDay":true,"disabledTime":true}]',
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
];
